module.exports = __webpack_public_path__ + "static/media/badge_yishu.2309ad8d.svg";